import type { Requisition, RequisitionDetailsFormFields } from '@recruitee/requisitions-types';

import {
  AvailableFieldsMap,
  ContextFormFields,
  DetailsFormFields,
  LocationFormFields,
  OpeningsFormFields,
  WorkModelFormFields,
} from '../requisitions.types';

export class RequisitionFormDataAdapter {
  // eslint-disable-next-line max-lines-per-function
  public getFormValues(requisition: Requisition): Partial<Requisition> & {
    workModel: {
      onSite: boolean;
      hybrid: boolean;
      remote: boolean;
    };
  } {
    const {
      category,
      departmentId,
      education,
      employmentType,
      experience,
      generalContextJson,
      hiringBudget,
      hiringBudgetCurrency,
      hiringManagerId,
      hybrid,
      minHoursPerWeek,
      maxHoursPerWeek,
      onSite,
      recruiterId,
      remote,
      salary,
    } = requisition;
    return {
      category,
      departmentId,
      education,
      employmentType,
      experience,
      generalContextJson,
      hiringBudget,
      hiringBudgetCurrency,
      hiringManagerId,
      minHoursPerWeek,
      maxHoursPerWeek,
      recruiterId,
      salary,
      workModel: {
        onSite,
        hybrid,
        remote,
      },
    };
  }

  public getAvailableFields(
    availableFormFields: RequisitionDetailsFormFields[],
  ): AvailableFieldsMap {
    return availableFormFields.reduce(
      (result, field) => {
        const isContext = ContextFormFields.includes(field);
        const isDetails = DetailsFormFields.includes(field);
        const isLocation = LocationFormFields.includes(field);
        const isWorkModel = WorkModelFormFields.includes(field);
        const isOpenings = OpeningsFormFields.includes(field);

        if (isContext) result.context = { ...result.context, [field]: true };
        if (isDetails) result.details = { ...result.details, [field]: true };
        else if (isLocation) result.location = { ...result.location, [field]: true };
        else if (isWorkModel) result.workModel = { ...result.workModel, [field]: true };
        else if (isOpenings) result.openings = { ...result.openings, [field]: true };
        return {
          ...result,
        };
      },
      { context: {}, details: {}, location: {}, openings: {}, workModel: {} },
    );
  }
}
